module.exports = __webpack_public_path__ + "static/img/200284.d0a698b8.png";